var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c("loading-screen", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading",
          },
        ],
      }),
      _vm._v(" "),
      _c("toolbar", {
        on: {
          "show-snackbar-message": _vm.showSnackbarMessage,
          "reset-wheel": function ($event) {
            return _vm.resetWheel()
          },
          "open-open-dialog": function ($event) {
            return _vm.openOpenDialog()
          },
          "open-save-dialog": function ($event) {
            return _vm.openSaveDialog()
          },
          "open-share-dialog": function ($event) {
            return _vm.openShareDialog()
          },
          "open-customize-dialog": function ($event) {
            return _vm.openCustomizeDialog()
          },
          "open-twitter-dialog": function ($event) {
            return _vm.openTwitterDialog()
          },
          "open-sheet-dialog": function ($event) {
            return _vm.openSheetDialog()
          },
          "set-locale": _vm.setLocale,
        },
      }),
      _vm._v(" "),
      _c(
        "section",
        {
          staticClass: "section",
          staticStyle: { "padding-top": "1rem", "padding-bottom": "0" },
        },
        [
          _c(
            "div",
            {
              staticClass: "columns",
              class: { "is-centered": _vm.$store.state.appStatus.fullScreen },
            },
            [
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.$store.state.appStatus.fullScreen,
                    expression: "!$store.state.appStatus.fullScreen",
                  },
                ],
                staticClass: "column is-3",
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "column is-6",
                  class: { "is-7": _vm.$store.state.appStatus.fullScreen },
                },
                [
                  _c("spinningwheel", {
                    ref: "spinningwheel",
                    on: {
                      "wheel-started": _vm.wheelStarted,
                      "name-changed": _vm.nameChanged,
                      "wheel-stopped": _vm.wheelStopped,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.$store.state.appStatus.fullScreen,
                      expression: "!$store.state.appStatus.fullScreen",
                    },
                  ],
                  staticClass: "column is-3",
                },
                [
                  _c("span", { staticStyle: { "font-family": "Quicksand" } }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("app.Enter names here")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("textboxbuttons"),
                  _vm._v(" "),
                  _c("textbox"),
                  _vm._v(" "),
                  _c("entry-counter"),
                  _vm._v(" "),
                  _c("app-info", {
                    on: {
                      "open-options-dialog": function ($event) {
                        return _vm.openOptionsDialog()
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("opendialog", {
        ref: "opendialog",
        on: {
          "show-snackbar-message": _vm.showSnackbarMessage,
          "start-wait-animation": _vm.startWaitAnimation,
          "stop-wait-animation": _vm.stopWaitAnimation,
          "auth-error": _vm.authError,
          "reset-wheel-rotation": _vm.resetWheelRotation,
        },
      }),
      _vm._v(" "),
      _c("savedialog", {
        ref: "savedialog",
        on: {
          "show-snackbar-message": _vm.showSnackbarMessage,
          "start-wait-animation": _vm.startWaitAnimation,
          "stop-wait-animation": _vm.stopWaitAnimation,
          "auth-error": _vm.authError,
        },
      }),
      _vm._v(" "),
      _c("optionsdialog", {
        ref: "optionsdialog",
        on: { "show-snackbar-message": _vm.showSnackbarMessage },
      }),
      _vm._v(" "),
      _c("sharedialog", {
        ref: "sharedialog",
        on: {
          "show-snackbar-message": _vm.showSnackbarMessage,
          "start-wait-animation": _vm.startWaitAnimation,
          "stop-wait-animation": _vm.stopWaitAnimation,
        },
      }),
      _vm._v(" "),
      _c("twitterdialog", {
        ref: "twitterdialog",
        on: {
          "show-snackbar-message": _vm.showSnackbarMessage,
          "start-wait-animation": _vm.startWaitAnimation,
          "stop-wait-animation": _vm.stopWaitAnimation,
        },
      }),
      _vm._v(" "),
      _c("sheetdialog", {
        ref: "sheetdialog",
        on: {
          "show-snackbar-message": _vm.showSnackbarMessage,
          "auth-error": _vm.authError,
        },
      }),
      _vm._v(" "),
      _c("winnerdialog", {
        ref: "winnerdialog",
        on: {
          "remove-name": _vm.removeName,
          "remove-name-all": _vm.removeNameAll,
        },
      }),
      _vm._v(" "),
      _c("winneranimation", { ref: "winneranimation" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }